export const errorsParser = (errors: any) => {
  return Object.entries(errors).reduce<
    { key: string; message: string; messageWithLabel: string }[]
  >((acc, [key, value]) => {
    const label = key.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase());
    const valueKeys = Object.entries(value as Record<string, any>).map(([subKey, msg]) => ({
      key: `${key}_${subKey}`,
      message: msg.charAt(0).toUpperCase() + msg.slice(1),
      messageWithLabel: `${label}: ${msg}`,
    }));
    return acc.concat(valueKeys);
  }, []);
};
